import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';
// import { WooActionsGridWidgetComponent } from  '../woo/woo-actions-grid-widget/woo-actions-grid-widget.component';
import { VariableCodeBlock } from 'src/app/shared/models/variableCodeBlockModel.model';


@Component({
  selector: 'app-variable-code-blocks-grid',
  templateUrl: './variable-code-blocks-grid.component.html',
  styleUrls: ['./variable-code-blocks-grid.component.scss']
})
export class VariableCodeBlocksGridComponent implements OnInit {



 // set this in the parent
//  doSomethingchild() {
//   this.refreshGrid();
// }
// set this in the parent
// add this to the drectives directives: [WooActionsGridWidgetComponent] // child component name
    // @ViewChild(WooActionsGridWidgetComponent) child:WooActionsGridWidgetComponent; // constructor
  /*
  ngAfterViewInit() {
      // child is set
      this.child.doSomethingChild();
    }
    */

    // @ViewChild(WooActionsGridWidgetComponent) child:WooActionsGridWidgetComponent;

    @ViewChild('promotionsForm') form: any;
    @Input() sent_data?: any; // not used
  
    // Grid Vars
    public data: DataManager;
    public data_subjects: DataManager;
    public pageSettings: Object;
    public pageOptions = { pageSize: 25 }; 
    public filterOptions: FilterSettingsModel;
    public formatOptions: Object;
    // public filterOptions: FilterSettingsModel;
    public filter : IFilter;
    public toolbarOptions: ToolbarItems[];
    @ViewChild('grid')
    public grid: GridComponent;
    public groupOptions: GroupSettingsModel;
    public templateOptionsDate: IFilterUI;
    public elem1: HTMLElement;
    public datePickerObj: DatePicker;
    public wrapSettings: TextWrapSettingsModel;
  
  
       // setup as observable?
       @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'side'; // side | abstract | full
  
  
    subjects_urgent: any;
    formatoptions: { type: string; format: string; };
    dateFormat: string;
    sortOptions: { columns: { field: string; direction: string; }[]; };
    today = new Date();
    initialPage: { pageSize: number; };
    open_jobs_count: any;
    myobCustomers: any;
    arrCase: object[];
    Items: any;
    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    all_router_details: string;
    myob_tax_codes_live: any;
    myob_tax_codes: any;
    created_myob_tax_account: any;
    updated_myob_tax_account: any;
    sessionUserName: string;
    sessionUserLevel: number;
    sessionUserFullName: string;
    sessionUserFirstName: string;
    action_lists: any;
    action_lists_table: any;
    action_list: any;
    action_list_removed: any;
  promotions: any;
  promotions_table: any;
  // variable_code_blocks: VariableCodeBlock; // set the looped value as a model. on a form do we do the model as the model?
  variable_code_blocks: any; // set the looped value as a model. on a form do we do the model as the model?
  variable_code_blocks_table: any; // set the looped value as a model.
  get_latest_variable_code_block_id: any;
  variable_code_blocks_metrix_search_full: any;
  brand_types: any;
  user_levels: any;
  brands_agent: any;
  variable_code_blocks_metrix_search_full_results: any;
  new_data: any;
  search_model: VariableCodeBlock;
  variable_code_job_types: any;
  job_service_timeframe: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_court: any;
  job_type_document: any;
  job_type_affidavit: any;
  job_type: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  variable_code_block_insert_types: any;
  addTypeClick: boolean;
  system_log_type_data_sectors: any;
   
   
  
  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService
    ) {   
  
      // Set and Access login Session Variables
      this.gfunc.setLoginSessionVars(); // set in a global function file
      this.sessionUserId = this.gfunc.currentUserVAR.user_id;
      this.sessionUsername = this.gfunc.currentUserVAR.username;
      this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  
            // So set session vars manually. PPS Distro Hub - No Loging Required
            // this.sessionUserId = 142;
            // this.sessionUsername = 'temperosystems';
            // this.sessionUserName = 'temperosystems';
            // this.sessionBrandId = 125;
            // this.sessionUserLevel = 1000;
            // this.sessionUserFullName = 'tempero user';
            // this.sessionUserFirstName = 'tempero';    
      
          // need to add this as routes does not work globally
          this.all_router_details = this.router.url;
          this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
          this.addTypeClick = false;
      
         }
      
         // check for changes. to load data.
         ngOnChanges(changes) {
          if (changes.item_id) {
            // deal with asynchronous Observable result
            this.item_id = changes.item_id.currentValue;
            // this.getJob(this.job_id);
          }
        }
  
        
    ngOnInit() {
  
        // this.getActionLists();

        this.search_model = new VariableCodeBlock();
        // this.getFormUserLevels();
        // this.getBrandBrandTypes();
        // this.getBrandsComboBoxAgents(this.combo_model);
        // this.getJobsTableData();

        this.search_model = {}// set to empty to get all first.

        this.getVariableCodeBlocksSearchFull(this.search_model);
        this.getVariableCodeBlockTypes();
        this.getVariableCodeBlockInsertTypes();
        this.getSystemLogTypeDataSectors();
        this.getJobTypes();

                // Grid Options
                this.toolbarOptions = ['Search'];
                // this.toolbarOptions = ['ExcelExport', 'Search'];
                this.initialPage = { pageSize:5 };
                this.filterOptions = {
                   type: 'Menu'
                };
               // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
                this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
                this.dateFormat = 'dd/MM/yyyy hh:mm a';
                this.filter = { params: { format: this.dateFormat } };
               // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
                  
         this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
            
            // end date filter options
                // End Grid Options
        }

      
        makeDuplicateVariableCodeBlock(model){
          if (confirm('We are about duplicate this item, Are you Sure?')) {
          // post a new With this model. & Name as copuy
          model.variable_code_block_name =  model.variable_code_block_name + '_COPY'
          if (model.variable_code_block_description != null){model.variable_code_block_description = '_COPY **** of **** ' + model.variable_code_block_description}
          if (model.variable_code_block_notes != null){model.variable_code_block_notes = '_COPY **** of **** ' + model.variable_code_block_notes}
          if (model.variable_code_block_as_actual_NAME != null){model.variable_code_block_as_actual_NAME = model.variable_code_block_as_actual_NAME + '_COPY'}
          if (model.variable_code_block_as_variable != null){ model.variable_code_block_as_variable = model.variable_code_block_as_variable + '_COPY'}
          if (model.variable_code_block_as_variable_NAME != null){model.variable_code_block_as_variable_NAME = model.variable_code_block_as_variable_NAME + '_COPY'}
          // model.is_active = '';
          this.createVariableCodeBlock(model);
          this.refreshGrid();
          }
        }
      
      
        createVariableCodeBlock(model) {
          // console.log(model);
            this._demoService.createVariableCodeBlock(model).subscribe(
                  data => {  this.get_latest_variable_code_block_id = data; // this is the retuned json upon creation.
        
                 this.toastr.success("Duplacte Created " + model.varable_code_block_name)
                 this.grid.refresh();
          /*
                  // tslint:disable-next-line:max-line-length
                  this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
                  this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
          */
                  // this.closeParentModel.emit();
                //   CreateJobTypeComponent.returned.next(false);
                    //  return true;
                  },
                  error => {
                    this.toastr.error('Adding Block Failed :: Please try again!');
                    // console.log(Observable.throw(error));
                    // return Observable.throw(error);
                  console.error(error);
                  }
            );
            }


            deleteVariableCodeBlock(variable_code_block_id) {
              if (confirm('Are you sure you want to delete this item, it cannot be undone!? ')) {
                this._demoService.deleteVariableCodeBlock(variable_code_block_id).subscribe(
                   data => {
                    let res=data;
                 // reset the plaintiff list.
                //  this.getJobPlaintiffs(this.job_id);
                 this.toastr.success('removed variable code block.');
                 this.grid.refresh();
                   
                   },
                   error => {
                     console.error('Error deleting !');
                    return console.log(error);
                   }
                );
            }
            }



        // :: Grid Functions
      
      
      // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
      clickHandler(args: ClickEventArgs): void {
        if (args.item.id === 'Click') {
      
        //  this.grid.showSpinner();
      
        //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
       //  console.log(args.data.items);
       
      
      
        let pdfdata;
        const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
        for (let i = 0; i < query.queries.length; i++) {
          if (query.queries[i].fn === 'onPage') {
            query.queries.splice(i, 1);       // remove page query to get all records
            break;
          }
        }
        const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
          pdfdata = e.result as object[];  // get all filtered records
          const exportProperties = {
            dataSource: pdfdata,
          };
          // console.log(pdfdata.results);
      
         // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*   this.search_results = pdfdata;
          this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
          this.toastr.success( "Press Start To Process Que");  */
         // this.grid.pdfExport(exportProperties);
        }).catch((e) => true);
        }
      
       //  this.grid.hideSpinner();
      
      };
      
      
      toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
            this.grid.excelExport();
        }
      }
      rowDataBound(args: RowDataBoundEventArgs) {
        const job_status = 'job_status';
        if (args.data[job_status] === 'CLOSED') {
            args.row.className = 'strikethrough';
        }
      }
      
        // :: Grid Functions
  
  
  
  
  
  
        public getMyobTaxCodesLive() {
          return  this._demoService.getMyobTaxCodesLive().subscribe(
              data => { this.myob_tax_codes_live = data;
                const res = data[0];
                 // https://www.concretepage.com/questions/577
                 this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                 // console.log(this.arrCase);
                 this.Items = data['Items'] ;
                 this.sent_data = this.Items;
        
                 // console.log(this.Items);
                // this.Address = this.Items['Address'];
          // return this.myobCustomers;
        
          // Map the data top the new model system
         // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
        
              },
              err => {
                // this.toastr.error('You need to login to MYOB again, Connection lost!');
               // console.error(err);
              },
              // () => console.log('done loading Trace Types')
            );
        
          }
    
  
          getMyobTaxCodes() {
            this._demoService.getMyobTaxCodes().subscribe(
               data => { this.myob_tax_codes = data;
                let res = data[0];
        
                // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                // // console.log(this.arrCase);
                // this.Items = data['Items'] ;
                // this.sent_data = this.Items;
                // this.sent_data = this.myob_account_codes;
        
              },
               err => console.error(err),
               // () => console.log('done loading Trace Types')
             );
           }
  
  
           refreshGrid(){ // refresh the databutton
            // this.loadList(this.doc_id);
            // this.getMyobTaxCodesLive();
            // this.getActionLists();
            this.search_model = {}// set to empty to get all first.
            this.getVariableCodeBlocksSearchFull(this.search_model);
            this.grid.refresh();
          };
  
  
  
  
          createMyobTaxCodesImport(model) {
  
            let TaxCollectedAccount;
            let TaxPaidAccount;
  
            if (typeof model.TaxCollectedAccount === 'undefined' || model.TaxCollectedAccount === null ) {
              TaxCollectedAccount = null;
            }else {
              TaxCollectedAccount = model.TaxCollectedAccount.UID; // can only call if actuall exist in the array!
            };
  
            if (typeof model.TaxPaidAccount === 'undefined' || model.TaxPaidAccount === null ) {
              TaxPaidAccount = null;
            }else {
              TaxPaidAccount = model.TaxPaidAccount.UID;
            };
        
            let new_model = null;
            // :: Build New model
            new_model = {
              myob_tax_code_name: model.Code,
              myob_tax_code_code: model.Code,
              myob_tax_id: model.UID,
              tax_percentage: model.Rate,
              UID: model.UID,
              Code: model.Code,
              Description: model.Description,
              Type: model.Type,
              Rate: model.Rate,
              IsRateNegative: model.IsRateNegative,
              TaxCollectedAccountUID: TaxCollectedAccount,
              TaxPaidAccountUID: TaxPaidAccount,
              LastModified: model.LastModified,
              RowVersion: model.RowVersion,
              myob_array: JSON.stringify(model)
            }; // multidimentional array push
        
        // run an external function to check the vaule - does not run before function not working
        // const check_val =  this.checkForLocalMyobAccountUID(model.UID);
        // console.log('Checked Value: ' + JSON.stringify(check_val));
        
        // lookup myob accounts row with UID = local UID then filter  and count the rows. then access array for variables.
        // tslint:disable-next-line:max-line-length
        const localTaxAccountsLInkedArr = Object(this.myob_tax_codes).filter((ac) => (ac.UID === model.UID)); // filter array of already looked up myob_account_codes data
        console.log('LocalCheckCount: ' + localTaxAccountsLInkedArr.length );
        const local_account_check_length = localTaxAccountsLInkedArr.length;
        
                    if (local_account_check_length === null || local_account_check_length === 0) {
                      console.log('We need to create this one.');
                          this._demoService.createMyobTaxCodes(new_model).subscribe(
                            data => {   this.created_myob_tax_account = data; // this is the retuned json upon creation.
                              //  let res = data[0];
                          this.toastr.success('Tax Code Created Locally');
                          // return true;
                            },
                            error => {
                              console.error(error);
                            });
        
                    } else {
                      console.log('We need to UPDATE this one');
                              const local_myob_tax_code_id = localTaxAccountsLInkedArr[0].myob_tax_code_id;
                              this._demoService.updateMyobTaxCodes(new_model, local_myob_tax_code_id).subscribe(
                                data => {   this.updated_myob_tax_account = data; // this is the retuned json upon creation.
                                  //  let res = data[0];
                              this.toastr.success('Tax Code Imported and Updated');
                              //  return true;
                                },
                                error => {
                                  console.error(error);
                                });
        
                    }
        this.getMyobTaxCodes(); // need to refresh the loop model for next press otherwise does not know of updates to myob_account_codes
           };
  
  
  
           getActionLists() {
            this._demoService.getActionLists().subscribe(
              data => {
                this.action_lists = data;
                this.action_lists_table = this.action_lists.slice(0, 10);
              },
              error => {
                 this.toastr.error( "Sorry, we were not able to get the lists");
                //  console.error('Error Loading User!');
                // return Observable.throw(error);
              }
            );
          }


          getPromotions() {
            this._demoService.getPromotions().subscribe(
              data => {
                this.promotions = data;
                this.promotions_table = this.promotions.slice(0, 10);
              },
              error => {
                 this.toastr.error( "Sorry, we were not able to get the promotions");
                //  console.error('Error Loading User!');
                // return Observable.throw(error);
              }
            );
          }
  

          
          getVariableCodeBlocks() {
            this._demoService.getVariableCodeBlocks().subscribe(
              data => {
                this.variable_code_blocks = data;
                this.variable_code_blocks_table = this.variable_code_blocks.slice(0, 10);
              },
              error => {
                 this.toastr.error( "Sorry, we were not able to get the promotions");
                //  console.error('Error Loading User!');
                // return Observable.throw(error);
              }
            );
          }
  
  
          getActionList(action_list_id){
            this._demoService.getActionList(action_list_id).subscribe(
              res => {this.action_list = res;
              this.refreshGrid();
              },
              err => {
              this.toastr.error( "Sorry, we were not able to get the list");
                console.error(err.status);
                      }
            );
           }
          
  
           deleteActionList(action_list_id){
          if (confirm('Are you sure you wish to delete this action list? ID=' + action_list_id)) {
            this._demoService.deleteActionList(action_list_id).subscribe(
              res => {this.action_list_removed = res;
                this.toastr.success( "Done, action list removed.");
                this.refreshGrid();
              },
              err => {
              this.toastr.error( "Sorry, we were not able to delete the list");
                console.error(err.status);
                }
            );
                    }// end confirm
           }
  
  
  
  
           getBrandBrandTypes(){
            this._demoService.getBrandBrandTypes().subscribe(
              data => { this.brand_types = data;
               let res = data[0];
             },
              err => console.error(err),
              // () => console.log('done loading Trace Types')
            );
          }
  
          getFormUserLevels() {
            this._demoService.getFormUserLevels().subscribe(
               data2 => { this.user_levels = data2;
                console.log(data2);
             },
               err => console.error(err),
               () => console.log('done loading User Levels')
             );
           }
        

           getBrandsComboBoxAgents(combo_model) {
            // this.combo_model.brand_type_id = 3;
           this._demoService.getBrandsComboBox(combo_model).subscribe(
              data => { this.brands_agent = data; },
              err => console.error(err),
              // () => console.log('done loading Trace Types')
            );
          }
      
          


          getVariableCodeBlocksSearchFull(search_model) {
            // search_model.brand_type_id = 3;
            // search_model.access_level = 5;
            this._demoService.getVariableCodeBlocksSearchFull(search_model).subscribe(
              data => { this.variable_code_blocks_metrix_search_full = data;
               let res = data[0];
                // pass so that the dates are correct in Sync
                // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
               
               
                this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                // this.subject_service_metrix_search_full_results = data;
                this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 500);
          
              
  
              //  this.grid.refresh();
            
                },
                error => {
                console.error('Error Loading !' + error.error);
                console.log(error);
                // return Observable.throw(error);
                }
                );
                 
          
          }
  
          
          
   getVariableCodeBlockTypes() {
    this._demoService.getVariableCodeBlockTypes().subscribe(
        data => { this.variable_code_job_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }

    getVariableCodeBlockInsertTypes() {
      this._demoService.getVariableCodeBlockInsertTypes().subscribe(
          data => { this.variable_code_block_insert_types = data; },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }
   

  getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data;
        let res = data[0];
      
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
   // this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }


  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
       data => { this.job_type_court = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
       data => { this.job_type_document = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
       data => { this.job_type_affidavit = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   



   getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


    
   getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

  }

clearSearchResults(search_model){
this.new_data = [];
this.search_model = {}// set to empty to get all first.
this.getVariableCodeBlocksSearchFull(this.search_model);
this.grid.refresh()

}



getSystemLogTypeDataSectors() {
  this._demoService.getSystemLogTypeDataSectors().subscribe(
     data => { this.system_log_type_data_sectors = data;
    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }

  
  }
  